import React from "react";
import "./aksiya.css";
function Aksiya(props) {
  return (
    <div className="container">
      <div
        className=" d-inline-block p-5 shadow-custom my-5 alert alert-warning"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdrop"
      >
        {props.aksiya_info.toUpperCase()}
      </div>

      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {props.aksiya_info}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="container">
                <h1>{props.aksiya_title}</h1>
                <br />
                <p>{props.aksiya_body}</p>
                <img src={props.img} alt="" className="w-100" />

                <h2 className="fs-1 my-5">Появились вопросы?</h2>
                <h2 className="fs-3 my-3">
                  Менеджер перезвонит вам и ответит на вопросы
                </h2>
                <form action="">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="input-group">
                        <span className="input-group-text">Full-Name</span>
                        <input
                          type="text"
                          aria-label="First name"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-12 mt-3">
                      <div className="mb-3">
                        <label htmlFor="formGroupExampleInput" className="form-label">
                         Phone:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="formGroupExampleInput"
                          placeholder="Example input placeholder"
                        />
                      </div>
                    </div>
                    <div className="col-sm-12 mt-3">
                      <div className="mb-3">
                        <label htmlFor="formGroupExampleInput" className="form-label">
                          Example label
                        </label>
                      <select className="form-control" name="" id="">
                        <option value="">Anytime</option>
                        <option value="">9-12</option>
                        <option value="">12-15</option>
                        <option value="">15-18</option>
                        <option value="">18-21</option>
                      </select>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Understood
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Aksiya;
